import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DashboardLayout from './DashboardLayout';
import { DASHBOARD_ALLOWED_ROLES } from '../data/menu-items';

// Routes réservées à l'admin uniquement
const ADMIN_ONLY_ROUTES = [
  '/admin/reports',
  '/admin/reports/finance',
  '/admin/reports/stock',
];

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#f8f9fa'
      }}>
        <div style={{
          textAlign: 'center'
        }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '4px solid #e5e7eb',
            borderTopColor: '#c5a05e',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1rem'
          }}></div>
          <p style={{ color: '#6b7280' }}>Chargement...</p>
        </div>
      </div>
    );
  }

  // Non authentifié -> redirection vers login
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  const userRole = user?.role || 'client';

  // Vérifier si l'utilisateur a le droit d'accéder au dashboard
  // Les clients ne peuvent JAMAIS accéder au dashboard
  if (!DASHBOARD_ALLOWED_ROLES.includes(userRole)) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#f8f9fa',
        flexDirection: 'column',
        textAlign: 'center',
        padding: '20px'
      }}>
        <div style={{
          background: '#fff',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          maxWidth: '400px'
        }}>
          <div style={{
            width: '60px',
            height: '60px',
            background: '#fee2e2',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px'
          }}>
            <span style={{ fontSize: '30px' }}>🚫</span>
          </div>
          <h2 style={{ color: '#dc2626', marginBottom: '10px' }}>Accès Refusé</h2>
          <p style={{ color: '#6b7280', marginBottom: '20px' }}>
            Vous n'avez pas les permissions nécessaires pour accéder à cette zone.
          </p>
          <a 
            href="/" 
            style={{
              display: 'inline-block',
              background: '#c5a05e',
              color: '#fff',
              padding: '10px 20px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '500'
            }}
          >
            Retour à l'accueil
          </a>
        </div>
      </div>
    );
  }

  // Vérifier si la route est réservée à l'admin
  const isAdminOnlyRoute = ADMIN_ONLY_ROUTES.some(route => 
    location.pathname.startsWith(route)
  );

  // Si c'est une route admin et l'utilisateur n'est pas admin -> accès refusé
  if (isAdminOnlyRoute && userRole !== 'admin') {
    return (
      <DashboardLayout>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '60vh',
          flexDirection: 'column',
          textAlign: 'center',
          padding: '20px'
        }}>
          <div style={{
            background: '#fff',
            padding: '40px',
            borderRadius: '12px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            maxWidth: '400px'
          }}>
            <div style={{
              width: '60px',
              height: '60px',
              background: '#fef3c7',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px'
            }}>
              <span style={{ fontSize: '30px' }}>⚠️</span>
            </div>
            <h2 style={{ color: '#d97706', marginBottom: '10px' }}>Accès Limité</h2>
            <p style={{ color: '#6b7280', marginBottom: '20px' }}>
              Cette page est réservée aux administrateurs uniquement.
            </p>
            <a 
              href="/admin/dashboard" 
              style={{
                display: 'inline-block',
                background: '#c5a05e',
                color: '#fff',
                padding: '10px 20px',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '500'
              }}
            >
              Retour au tableau de bord
            </a>
          </div>
        </div>
      </DashboardLayout>
    );
  }

  return <DashboardLayout>{children}</DashboardLayout>;
};

export default ProtectedRoute;
